import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quote",
  "use": "icon-quote-usage",
  "viewBox": "0 0 150 151",
  "content": "<symbol viewBox=\"0 0 150 151\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-quote\">\r\n<path d=\"M101.333 150.112V71.7946C101.333 33.2999 122 9.40662 150 0.77861V25.3359C139.333 31.9733 127.333 42.5919 127.333 69.1399V91.7066H150V150.112H101.333ZM0.666626 150.112V71.7946C0.666626 33.2999 21.3333 9.40662 49.3333 0.77861V25.3359C38.6666 31.9733 26.6666 42.5919 26.6666 69.1399V91.7066H49.3333V150.112H0.666626Z\" fill=\"#323232\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol